/* eslint-disable no-undef */
import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter as Router } from 'react-router-dom';
import OneSignal from 'react-onesignal';

import { getUserBrowserLanguage } from '@ts-core/utils/languageUtils';

import { I18NProvider } from '@ts-core/lib/i18n';
import { SnackbarProvider } from '@ts-core/lib/snackbar';

import { createApolloClient } from 'core/utils/apollo';
import { createTheme } from '@ts-core/core/theme';

import enMessages from '@ts-core/strings/en.json';
import esMessages from '@ts-core/strings/es.json';

import App from './App';

import 'moment/locale/es';
moment.locale('es');

const currentLanguage = getUserBrowserLanguage();
const messages: Record<string, string> = currentLanguage === 'en' ? enMessages : esMessages;

// Theme
const theme = createTheme();

// Apollo
const apolloClient = createApolloClient();

if (import.meta.env.VITE_STUDENT_ONE_SIGNAL_ID) {
  OneSignal.init({ appId: import.meta.env.VITE_STUDENT_ONE_SIGNAL_ID });
}

const Application = (
  <I18NProvider language={currentLanguage} messages={messages}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ApolloProvider client={apolloClient}>
          <SnackbarProvider>
            <Router>
              <App />
            </Router>
          </SnackbarProvider>
        </ApolloProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </I18NProvider>
);

ReactDOM.render(Application, document.getElementById('root'));
